/**
 * Single import point for anime.js v4, mirroring the shape of lib/gsap.js.
 *
 * Library boundary — this matters, because two animation runtimes share the
 * page and no element may be owned by both:
 *
 *   GSAP     owns everything scroll-linked (ScrollTrigger, pins, scrubs, Flip)
 *            and drives the Lenis ticker.
 *   anime.js owns everything that is not: the boot sequence, the menu, pointer
 *            micro-interactions, SVG drawing and morphing, grid staggers,
 *            springs, and the field's uniform objects.
 */
import {
  animate,
  createTimeline,
  createTimer,
  createScope,
  createSpring,
  createDraggable,
  createAnimatable,
  stagger,
  utils,
  svg,
  text,
  engine,
} from "animejs";

/* Anime pauses itself when the tab is hidden — the field and the marquee
   should not burn frames in a background tab. */
engine.pauseOnDocumentHidden = true;

/** Motion language, matched to the GSAP curves already in use. */
export const ANIME_EASE = {
  out: "outQuart",
  io: "inOutExpo",
  soft: "outQuad",
};

export const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export {
  animate,
  createTimeline,
  createTimer,
  createScope,
  createSpring,
  createDraggable,
  createAnimatable,
  stagger,
  utils,
  svg,
  text,
  engine,
};
